import { render, staticRenderFns } from "./FailedPaymentNotificationBar.vue?vue&type=template&id=2a1cf78b&scoped=true&"
import script from "./FailedPaymentNotificationBar.vue?vue&type=script&lang=js&"
export * from "./FailedPaymentNotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./FailedPaymentNotificationBar.vue?vue&type=style&index=0&id=2a1cf78b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1cf78b",
  null
  
)

export default component.exports